module.exports = "/virtual-football-league/img/amblems/right/logos/CrystalPalace.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/logos/CrystalPalace.png
// module id = 2168
// module chunks = 4